import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator, storeAreYouSureModalCallback } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import CustomTextInput from "../../../components/CustomTextInput";
import { YurticiCargoAgreementSchemeService } from "../../../services/YurticiCargoAgreementSchemeService";
import CustomDatePicker from "../../../components/CustomDatePicker";
import CustomNumberInput from "../../../components/CustomNumberInput";
import { YurticiCargoAgreementService } from "../../../services/YurticiCargoAgreementService";
import { AddYurticiCargoAgreementRequest } from "../../../models/request/yurticiCargoAgreement/AddYurticiCargoAgreementRequest";
import { GetYurticiCargoAgreementByIdResponse, GetYurticiCargoAgreementByIdResponseYurticiCargoAgreementScale } from "../../../models/response/yurticiCargoAgreement/GetYurticiCargoAgreementByIdResponse";
import { AddYurticiCargoAgreementResponse } from "../../../models/response/yurticiCargoAgreement/AddYurticiCargoAgreementResponse";
import ScaleInformation from "./Components/ScaleInformation";
import { GetYurticiCargoAgreementSchemeByIdResponse, GetYurticiCargoAgreementSchemeByIdResponseData } from "../../../models/response/yurticiCargoAgreementScheme/GetYurticiCargoAgreementSchemeByIdResponse";
import CustomSwitch from "../../../components/CustomSwitch";
import moment from "moment";

const YurticiCargoAgreementAdd = () => {
    const navigate = useNavigate();
    const pageName = "Kargo Modülü > Yurtiçi Kargo > Anlaşma"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const scaleInformationRef: any = useRef();

    const [yurticiCargoAgreementId, setYurticiCargoAgreementId] = useState<string | undefined>(undefined);
    const [refNo, setRefNo] = useState<string | undefined>(undefined);
    const [selectedAgreementScheme, setSelectedAgreementScheme] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedPotType, setSelectedPotType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedRegion, setSelectedRegion] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [startDate, setStartDate] = useState<string | undefined>(moment().startOf('year').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState<string | undefined>(moment().endOf('year').format('YYYY-MM-DD'));
    const [unitPrice, setUnitPrice] = useState<string | undefined>(undefined);
    const [minPrice, setMinPrice] = useState<string | undefined>('0');
    const [potTypeNotEqual, setPotTypeNotEqual] = useState<boolean>(false);

    const [yurticiCargoAgreementScales, setYurticiCargoAgreementScales] = useState<GetYurticiCargoAgreementByIdResponseYurticiCargoAgreementScale[]>([]);

    const [selectedYurticiCargoAgreementScheme, setSelectedYurticiCargoAgreementScheme] = useState<GetYurticiCargoAgreementSchemeByIdResponseData | undefined>(undefined);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetYurticiCargoAgreementByIdResponse = await YurticiCargoAgreementService.getYurticiCargoAgreementById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setYurticiCargoAgreementId(response.data.yurticiCargoAgreementId);
                setRefNo(response.data.refNo);

                if (response.data.agreementSchemeId && response.data.agreementSchemeName) {
                    setSelectedAgreementScheme({ label: response.data.agreementSchemeName, value: response.data.agreementSchemeId });

                    var response2: GetYurticiCargoAgreementSchemeByIdResponse = await YurticiCargoAgreementSchemeService.getYurticiCargoAgreementSchemeById(response.data.agreementSchemeId);

                    if (!response2.isSuccess) {
                        toast.error(response2.message)
                        return;
                    }

                    setSelectedYurticiCargoAgreementScheme(response2.data);
                }

                if (response.data.potTypeId && response.data.potTypeName)
                    setSelectedPotType({ label: response.data.potTypeName, value: response.data.potTypeId });

                setPotTypeNotEqual(response.data.potTypeNotEqual);

                if (response.data.regionId && response.data.regionName)
                    setSelectedRegion({ label: response.data.regionName, value: response.data.regionId });

                setStartDate(response.data.startDate);
                setEndDate(response.data.endDate);
                setUnitPrice(response.data.unitPrice?.toString());
                setMinPrice(response.data.minPrice?.toString());

                setYurticiCargoAgreementScales(response.data.yurticiCargoAgreementScales);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveYurticiCargoAgreement = async () => {
        try {
            if (!selectedYurticiCargoAgreementScheme)
                return;
            else if (!selectedAgreementScheme)
                toast.error('Şablon alanını doldurunuz!')
            else if (Helpers.isEmpty(startDate))
                toast.error('Başlangıç Tarihi alanını doldurunuz!')
            else if (Helpers.isEmpty(endDate))
                toast.error('Bitiş Tarihi alanını doldurunuz!')
            else if (selectedYurticiCargoAgreementScheme.isComplete && Helpers.isEmpty(unitPrice))
                toast.error('Birim Fiyat alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var obj: AddYurticiCargoAgreementRequest = {
                    yurticiCargoAgreementId: yurticiCargoAgreementId,
                    agreementSchemeId: selectedAgreementScheme?.value,
                    endDate: endDate,
                    minPrice: minPrice,
                    potTypeId: selectedPotType?.value,
                    regionId: selectedRegion?.value,
                    refNo: refNo,
                    startDate: startDate,
                    unitPrice: unitPrice,
                    potTypeNotEqual: potTypeNotEqual,
                    yurticiCargoAgreementScales: yurticiCargoAgreementScales.map(function (x) {
                        return {
                            yurticiCargoAgreementScaleId: x.yurticiCargoAgreementScaleId.startsWith('newrecrd') ? undefined : x.yurticiCargoAgreementScaleId,
                            interval: x.interval?.toString(),
                            unitPrice: x.unitPrice?.toString(),
                            startPrice: x.startPrice?.toString()
                        }
                    }),
                }

                var response: AddYurticiCargoAgreementResponse = await YurticiCargoAgreementService.addYurticiCargoAgreement(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const onSchemeChange = async (selectedValue: CustomSingleSelectModel | undefined) => {
        setSelectedAgreementScheme(selectedValue);

        if (!selectedValue) {
            setSelectedYurticiCargoAgreementScheme(undefined);
            return;
        }

        try {
            dispatch(storeActivityIndicator(true));

            var response: GetYurticiCargoAgreementSchemeByIdResponse = await YurticiCargoAgreementSchemeService.getYurticiCargoAgreementSchemeById(selectedValue.value);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setSelectedYurticiCargoAgreementScheme(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className="row">
                                    <div className="col-md-4">
                                        <CustomTextInput isLabelRequired labelText="Kod" value={refNo} setValue={setRefNo} isDisabled />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            labelText="Şablon"
                                            isLabelRequired
                                            selectedValue={selectedAgreementScheme}
                                            onChange={onSchemeChange}
                                            onMenuOpen={() => YurticiCargoAgreementSchemeService.getYurticiCargoAgreementSchemeList()}
                                            labelName='name'
                                            valueName='yurticiCargoAgreementSchemeId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomDatePicker labelText="Başlangıç Tarihi" isLabelRequired value={startDate} setValue={setStartDate} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <Box flexDirection="row">
                                            <Box flexGrow={1} justifyContent="center">
                                                <CustomSingleSelect
                                                    labelText="Kap Cinsi"
                                                    isLabelRequired
                                                    selectedValue={selectedPotType}
                                                    onChange={setSelectedPotType}
                                                    onMenuOpen={() => ConstantService.getConstantList('POT_TYPE')}
                                                    labelName='value'
                                                    valueName='constantId'
                                                />
                                            </Box>
                                            <Box width="80px" ml='15px' justifyContent="center">
                                                <CustomSwitch
                                                    labelText="Eşit Değil"
                                                    isActive={potTypeNotEqual}
                                                    setIsActive={setPotTypeNotEqual}
                                                />
                                            </Box>
                                        </Box>
                                    </div>

                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            labelText="Bölge"
                                            selectedValue={selectedRegion}
                                            onChange={setSelectedRegion}
                                            onMenuOpen={() => ConstantService.getConstantList('SHIPPING_REGION_YURTICI')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomDatePicker labelText="Bitiş Tarihi" isLabelRequired value={endDate} setValue={setEndDate} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <CustomNumberInput labelText="Birim Fiyat" isLabelRequired value={unitPrice} setValue={setUnitPrice} />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomNumberInput labelText="Minimum Fiyat" isLabelRequired value={minPrice} setValue={setMinPrice} />
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    {
                        (selectedYurticiCargoAgreementScheme && selectedYurticiCargoAgreementScheme.isScale) && (
                            <ScaleInformation
                                scaleInformationRef={scaleInformationRef}
                                setYurticiCargoAgreementScales={setYurticiCargoAgreementScales}
                                yurticiCargoAgreementScales={yurticiCargoAgreementScales}
                            />
                        )
                    }

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveYurticiCargoAgreement}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default YurticiCargoAgreementAdd;